import type { BATCH_CALL_STATUS } from '@/constants';
import { createListStore, createListStoreWithQuery } from '@/store/list-state.factory';

export type BatchCallStatusValue = 'All' | (typeof BATCH_CALL_STATUS)[number]['value'];

export type BatchCallFilters = {
  status: BatchCallStatusValue;
};

export const useSchedulerListStore = createListStoreWithQuery('schedulder-list-state', {
  filterDefaults: {
    status: 'All' as BatchCallStatusValue,
  },
});
export const useRecipientListStore = createListStore('schedulder-recipient-list-state');
